"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _withIcon = _interopRequireDefault(require("./withIcon"));
const DropdownPrizm = ({
  size,
  ...props
}) => {
  switch (size) {
    case 16:
      return _react.default.createElement("svg", (0, _extends2.default)({
        width: "16",
        height: "16",
        viewBox: "0 0 16 16"
      }, props), _react.default.createElement("path", {
        fillRule: "evenodd",
        d: "M7.293 10.707a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L8 8.585 4.707 5.293a1 1 0 10-1.414 1.414l4 4z"
      }));
    case 24:
    default:
      return _react.default.createElement("svg", (0, _extends2.default)({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
      }, props), _react.default.createElement("path", {
        fillRule: "evenodd",
        d: "M11.293 15.207a1 1 0 001.414 0l5-5a1 1 0 10-1.414-1.414L12 13.085 7.707 8.793a1 1 0 10-1.414 1.414l5 5z"
      }));
  }
};
const DropdownMDS = ({
  size,
  ...props
}) => {
  switch (size) {
    case 16:
      return _react.default.createElement("svg", (0, _extends2.default)({
        width: "16",
        height: "16",
        viewBox: "0 0 16 16"
      }, props), _react.default.createElement("path", {
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: "10",
        d: "M3.5 6.5L8 11l4.5-4.5"
      }));
    case 24:
    default:
      return _react.default.createElement("svg", (0, _extends2.default)({
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24"
      }, props), _react.default.createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fillRule: "evenodd"
      }, _react.default.createElement("polygon", {
        points: "11.9571068 13.25 7.95710678 9.25 7.25 9.95710678 11.9571068 14.6642136 16.6642136 9.95710678 15.9571068 9.25"
      })));
  }
};
const AbstractDropdown = ({
  theme,
  ...other
}) => theme.name === 'mds' ? _react.default.createElement(DropdownMDS, other) : _react.default.createElement(DropdownPrizm, other);
var _default = exports.default = (0, _styledComponents.withTheme)((0, _withIcon.default)('Dropdown')(AbstractDropdown));